import type { GetDetailedSummaryExpensesRequestProps } from '@services/api/otherExpenses/types'
import type { GetDetailedSummaryExpensesFormProps } from '../context/types'

export const parseGetDetailedSummaryExpensesPayload = (formData: GetDetailedSummaryExpensesFormProps) => {
  const payload: GetDetailedSummaryExpensesRequestProps = {
    routeParams: {
      filiCode: formData.filiCode!
    },
    bodyParams: {
      consumptionReferenceDate: formData.competenceDate!,
      currentPage: formData.page!,
      itemsPerPage: formData.itemsPerPage!,
      sortBy: formData.sortType ? formData.sortBy! : null,
      sortType: formData.sortType || null,
      accountingCodeFilter: formData.account ? (formData.account === 'Todos' ? null : [formData.account]) : null,
      accountingDescriptionFilter: formData.accountDescription
        ? formData.accountDescription === 'Todos'
          ? null
          : [formData.accountDescription]
        : null
    }
  }

  return payload
}
